<template>
    <!-- PC余额明细（表格版） -->
    <ZhaiHeadPC class="zhai-head" />

    <div class="container errong">
        <!-- 顶部栏：只保留推广中心 -->
        <div class="container-fluid mt-3">
            <div class="row shengse mt-2">
                <div class="dixian px-3 py-2 top-bar-pc">
                    <div class="left promo-title lf" @click="goBack">
                        <i class="fa ff fa-bullhorn"></i> 推广中心
                    </div>
                </div>
            </div>
        </div>

        <!-- 主体 -->
        <div class="bd-body">
            <div class="bd-shell">
                <!-- 页头 -->
                <div class="page-head">
                    <div class="ph-left">
                        <div class="ph-title">余额明细</div>
                        <div class="ph-sub">按收入/支出查看余额变动（提现请到提现明细）</div>
                    </div>

                    <div class="ph-right">
                        <button class="btn-soft" @click="goMyWallet">
                            <i class="fa fa-rmb"></i> 我的钱包
                        </button>
                    </div>
                </div>

                <!-- Tab + 跳转 -->
                <div class="tab-bar">
                    <button class="tab-btn" :class="{ active: activeTab === 'all' }" @click="changeTab('all')">
                        全部
                    </button>

                    <button class="tab-btn" :class="{ active: activeTab === 'out' }" @click="changeTab('out')">
                        支出
                    </button>

                    <button class="tab-btn" :class="{ active: activeTab === 'in' }" @click="changeTab('in')">
                        收入
                    </button>

                    <div class="tab-spacer"></div>

                    <button class="tab-link" @click="goWithdrawalDetails">
                        提现明细 <span class="chev">›</span>
                    </button>
                </div>

                <!-- ✅ 表格区 -->
                <div class="table-card">
                    <!-- 加载中 -->
                    <div v-if="loading" class="empty-line">
                        <span class="text">加载中…</span>
                    </div>

                    <!-- 错误态 -->
                    <div v-else-if="error" class="empty-line">
                        <span class="text">{{ error }}</span>
                    </div>

                    <!-- 空状态 -->
                    <div v-else-if="detailList.length === 0" class="empty-line">
                        <span class="line"></span>
                        <span class="text">我是有底线的</span>
                        <span class="line"></span>
                    </div>

                    <!-- 表格（v-else 必须紧跟 v-if / v-else-if） -->
                    <div v-else class="table-wrap">
                        <table class="bd-table">
                            <thead>
                            <tr>
                                <th style="width: 38%;">标题</th>
                                <th style="width: 14%;">类型</th>
                                <th style="width: 18%;">金额</th>
                                <th style="width: 30%;">时间</th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="item in detailList" :key="item.id">
                                <td class="td-title">
                                    <div class="title-main">{{ item.title }}</div>
                                    <div class="title-sub">单号：{{ item.orderNo || "—" }}</div>
                                </td>

                                <td>
                    <span class="type-pill" :class="typeClass(item.type)">
                      {{ item.typeText }}
                    </span>
                                </td>

                                <td class="td-money">
                    <span class="money" :class="{ plus: item.amount > 0, minus: item.amount < 0 }">
                      {{ formatMoney(item.amount) }}
                    </span>
                                </td>

                                <td class="td-time">{{ item.time || "—" }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- 分页：后端 total -->
                    <div class="pager-wrap" v-if="!loading && !error && totalPages > 1">
                        <div class="pager">
                            <button class="pager-btn" :disabled="page === 1 || pageChanging" @click="goPage(page - 1)">«</button>

                            <button class="pager-btn" :class="{ active: page === 1 }" :disabled="pageChanging" @click="goPage(1)">
                                1
                            </button>

                            <template v-if="totalPages >= 3">
                                <template v-if="page > 1 && page < totalPages">
                                    <button class="pager-btn dots" disabled>…</button>
                                    <button class="pager-btn active" disabled>{{ page }}</button>
                                    <button class="pager-btn dots" disabled>…</button>
                                </template>
                                <template v-else>
                                    <button class="pager-btn dots" disabled>…</button>
                                </template>
                            </template>

                            <button
                                    class="pager-btn"
                                    :class="{ active: page === totalPages }"
                                    :disabled="pageChanging"
                                    @click="goPage(totalPages)"
                            >
                                {{ totalPages }}
                            </button>

                            <button class="pager-btn" :disabled="page === totalPages || pageChanging" @click="goPage(page + 1)">
                                »
                            </button>
                        </div>

                        <div class="pager-loading" v-if="pageChanging">加载中…</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="gongxi2"></div>
    <ZhaiFootPC />
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import http from "@/utils/http";

    export default {
        name: "PBalanceDetails",
        components: { ZhaiHeadPC, ZhaiFootPC },

        data() {
            return {
                activeTab: "all",

                loading: true,
                pageChanging: false,
                error: "",

                page: 1,
                pageSize: 10,
                total: 0,

                // ✅ 接口返回覆盖这里
                detailList: [],

                // 参考同项目：更稳的 userId（可选传）
                currentUserId: null,
            };
        },

        computed: {
            totalPages() {
                const t = Number(this.total || 0);
                const s = Number(this.pageSize || 10);
                return Math.max(1, Math.ceil(t / s));
            },
        },

        // ✅ 路由守卫：未登录直接跳登录页（同提现明细）
        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        async mounted() {
            // ✅ mounted 再兜一次（同提现明细）
            const token = localStorage.getItem("token");
            if (!token) {
                if (this.$router) this.$router.replace("/login");
                else window.location.href = "/login";
                return;
            }

            this.currentUserId = this.resolveUserIdSafe();

            await this.fetchList(true);
        },

        methods: {
            goBack() {
                if (this.$router) this.$router.push("/Promotion");
                else window.location.href = "/Promotion";
            },
            goMyWallet() {
                if (this.$router) this.$router.push("/MyWallet");
                else window.location.href = "/MyWallet";
            },
            goWithdrawalDetails() {
                if (this.$router) this.$router.push("/WithdrawalDetails");
                else window.location.href = "/WithdrawalDetails";
            },

            changeTab(tab) {
                if (this.activeTab === tab) return;
                this.activeTab = tab;
                this.page = 1;
                this.fetchList(true);
            },

            async goPage(p) {
                const pageNum = Number(p);
                if (!pageNum || pageNum < 1 || pageNum > this.totalPages) return;
                if (pageNum === this.page) return;
                if (this.loading || this.pageChanging) return;

                this.pageChanging = true;
                this.page = pageNum;
                await this.fetchList(false);
                this.pageChanging = false;
            },

            // ✅ 参考同项目：更稳的 userId 获取
            resolveUserIdSafe() {
                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }
                return null;
            },

            // ✅ 拉余额明细（对齐后端：tab/page/pageSize/userId）
            async fetchList(reset = false) {
                try {
                    if (reset) {
                        this.loading = true;
                        this.error = "";
                    } else {
                        this.error = "";
                    }

                    const params = {
                        tab: this.activeTab, // all / in / out
                        page: this.page,
                        pageSize: this.pageSize,
                    };

                    // ✅ 和提现明细一样：有更稳的 userId 就传（没有也不影响）
                    if (this.currentUserId) params.userId = this.currentUserId;

                    const res = await http.get("/platform/withdraw/balanceDetail", params);
                    const json = res && res.data ? res.data : null;

                    if (!json || Number(json.status) !== 1) {
                        const msg = (json && json.msg) || "加载失败";

                        // ✅ 后端提示未登录：直接跳登录
                        if (msg.includes("未登录") || msg.includes("登录")) {
                            if (this.$router) this.$router.replace("/login");
                            else window.location.href = "/login";
                            return;
                        }

                        throw new Error(msg);
                    }

                    const data = json.data || {};
                    this.total = Number(data.total || 0);
                    this.page = Number(data.page || this.page);
                    this.pageSize = Number(data.pageSize || this.pageSize);
                    this.detailList = Array.isArray(data.list) ? data.list : [];
                } catch (e) {
                    this.detailList = [];
                    this.total = 0;
                    this.error = e && e.message ? e.message : "网络异常，请稍后再试";
                } finally {
                    this.loading = false;
                }
            },

            formatMoney(val) {
                const num = Number(val || 0);
                const abs = Math.abs(num).toFixed(2);
                if (num > 0) return `+${abs}`;
                if (num < 0) return `-${abs}`;
                return "0.00";
            },

            typeClass(t) {
                return { in: t === "in", out: t === "out" };
            },
        },
    };
</script>


<style scoped>
    /* 基础 */
    body { font-family: Arial, sans-serif; }
    .fa { margin-right: 6px; }
    .ff { margin-right: 6px;}
    .lf { font-weight: 700; }
    .gongxi2 { height: 20px; }
    .errong { padding-left: 30px; padding-right: 30px; }

    @media (min-width: 768px) {
        .zhai-head { position: fixed; top: 0; width: 100%; z-index: 1000; }
        .errong { margin-top: 80px; }
    }

    /* 顶部栏 */
    .top-bar-pc {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
    }
    .promo-title {
        cursor: pointer;
        user-select: none;
        font-size: 15px;
        color: #333;
        display: inline-flex;
        align-items: center;
    }
    .promo-title:active { opacity: 0.75; }
    .center {
        justify-self: center;
        font-size: 16px;
        font-weight: 900;
        color: #00c26f;
    }
    .right-placeholder { width: 1px; height: 1px; justify-self: end; }

    /* 主体壳 */
    .bd-body {
        background: #f3f4f6;
        border-radius: 2px;
        margin-top: 10px;
    }
    .bd-shell {
        max-width: 1200px;
        margin: 0 auto;
    }

    /* 页头 */
    .page-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 14px;
        background: #fff;
        border: 1px solid #eee;
        border-radius: 2px;
    }
    .ph-left { min-width: 0; }
    .ph-title { font-size: 16px; font-weight: 900; color: #111; }
    .ph-sub { margin-top: 6px; font-size: 13px; color: #888; }
    .ph-right { display: flex; gap: 10px; flex-wrap: wrap; }

    .btn-soft {
        height: 36px;
        padding: 0 12px;
        border-radius: 2px;
        border: 1px solid #eee;
        background: #fafafa;
        font-size: 13px;
        cursor: pointer;
        color: #333;
        display: inline-flex;
        align-items: center;
    }
    .btn-soft .fa { margin-right: 8px; color: #00c26f; }
    .btn-soft:active { opacity: 0.8; }

    /* Tabs */
    .tab-bar {
        margin-top: 10px;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 12px;
        background: #fff;
        border: 1px solid #eee;
        border-radius: 2px;
    }
    .tab-btn {
        height: 34px;
        padding: 0 14px;
        border-radius: 2px;
        border: 1px solid #e9e9e9;
        background: #fff;
        font-size: 13px;
        cursor: pointer;
        color: #333;
    }
    .tab-btn.active {
        border-color: #ff4d4f;
        color: #ff4d4f;
        background: #fff6f6;
        font-weight: 900;
    }
    .tab-btn:active { opacity: 0.85; }

    .tab-spacer { flex: 1; }

    .tab-link {
        height: 34px;
        padding: 0 12px;
        border-radius: 2px;
        border: 1px dashed #e1e1e1;
        background: #fff;
        font-size: 13px;
        cursor: pointer;
        color: #666;
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }
    .tab-link:hover { background: #fafafa; }
    .chev { color: #c7c7c7; font-size: 18px; line-height: 1; transform: translateY(-1px); }

    /* 表格卡片 */
    .table-card {
        margin-top: 12px;
        background: #fff;
        border: 1px solid #eee;
        border-radius: 2px;
        box-shadow: 0 6px 16px rgba(0,0,0,.04);
        overflow: hidden;
    }

    /* 表格容器（横向过宽时可滚动） */
    .table-wrap { overflow-x: auto; }

    /* 表格 */
    .bd-table {
        width: 100%;
        border-collapse: collapse;
        min-width: 860px;
    }
    .bd-table thead th {
        text-align: left;
        font-size: 13px;
        color: #666;
        font-weight: 900;
        background: #fafafa;
        border-bottom: 1px solid #eee;
        padding: 12px 14px;
    }
    .bd-table tbody td {
        padding: 12px 14px;
        border-bottom: 1px solid #f2f2f2;
        font-size: 13px;
        color: #333;
    }
    .bd-table tbody tr:hover {
        background: #fcfcfc;
    }

    /* 标题列 */
    .td-title .title-main {
        font-size: 14px;
        font-weight: 900;
        color: #111;
    }
    .td-title .title-sub {
        margin-top: 6px;
        font-size: 12px;
        color: #9aa0a6;
    }

    /* 类型 pill */
    .type-pill {
        display: inline-flex;
        align-items: center;
        height: 22px;
        padding: 0 8px;
        border-radius: 2px;
        font-size: 12px;
        font-weight: 900;
        border: 1px solid transparent;
    }
    .type-pill.in {
        color: #1f8a4c;
        background: #e9fff1;
        border-color: #b7eb8f;
    }
    .type-pill.out {
        color: #cf1322;
        background: #fff1f0;
        border-color: #ffccc7;
    }

    /* 金额 */
    .td-money { font-weight: 900; }
    .money.plus { color: #00c26f; }
    .money.minus { color: #ff4d4f; }

    .td-time { color: #666; }

    /* 空状态 */
    .empty-line {
        padding: 26px 12px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #9b9b9b;
        font-size: 14px;
    }
    .empty-line .line { width: 140px; height: 1px; background: #e9e9e9; margin: 0 14px; }
    .empty-line .text { white-space: nowrap; }

    /* 分页器（圆角2px） */
    .pager-wrap {
        padding: 14px 0 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #fff;
    }
    .pager {
        display: inline-flex;
        align-items: center;
        border-radius: 2px;
        overflow: hidden;
        border: 1px solid #e6e6e6;
        background: #fff;
    }
    .pager-btn {
        min-width: 34px;
        height: 32px;
        padding: 0 10px;
        border: 0;
        border-right: 1px solid #e6e6e6;
        background: #fff;
        color: #333;
        font-size: 18px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
        user-select: none;
    }
    .pager-btn:last-child { border-right: 0; }
    .pager-btn:disabled { opacity: 0.45; cursor: not-allowed; }
    .pager-btn.active {
        color: #00c26f;
        font-weight: 900;
        background: #f3fff8;
    }
    .pager-btn.dots { cursor: default; font-weight: 900; }
    .pager-btn:active:not(:disabled):not(.dots) { opacity: 0.75; }
    .pager-loading { margin-top: 8px; font-size: 12px; color: #9a9a9a; }
</style>
